if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton?.querySelector('span') || null;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.hideErrors = this.dataset.hideErrors === 'true';

        if (!this.form || !this.submitButton || !this.variantIdInput) return;

        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }

      onSubmitHandler(evt) {
        if (!this.form || !this.submitButton) return;
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner')?.classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText?.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              return czShowAddedPopup(response);
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner')?.classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage && this.errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (!this.submitButton || !this.submitButtonText) return;
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form?.querySelector('[name=id]') || null;
      }
    }
  );
}

// Cocooza : après un ajout, fenêtre « Ajouté à votre panier » avec les produits complémentaires
// (sections/cz-atc-popup.liquid). Sans suggestion à proposer, on garde la page panier du thème.
function czShowAddedPopup(item) {
  const goToCart = () => {
    window.location = window.routes.cart_url;
  };
  const url = `${window.Shopify.routes.root}products/${item.handle}?variant=${item.variant_id}&section_id=cz-atc-popup`;
  return fetch(url)
    .then((r) => r.text())
    .then((html) => {
      const dialog = new DOMParser().parseFromString(html, 'text/html').querySelector('.cz-atc');
      if (!dialog || !window.HTMLDialogElement) return goToCart();
      document.querySelectorAll('.cz-atc').forEach((old) => old.remove());
      document.body.appendChild(dialog);
      czRefreshCartBubble();

      // Fermeture faite ici plutôt que sur l'événement « close », qui n'est pas émis de façon fiable partout.
      const close = () => {
        dialog.close();
        document.documentElement.style.overflow = '';
        dialog.remove();
      };
      dialog.addEventListener('cancel', (e) => {
        e.preventDefault();
        close();
      });
      // Clic sur le fond (la fenêtre elle-même, hors contenu) ou sur un bouton de fermeture.
      dialog.addEventListener('click', (e) => {
        if (e.target === dialog || e.target.closest('[data-cz-close]')) close();
      });
      dialog.querySelectorAll('form').forEach((form) => {
        form.addEventListener('submit', (e) => {
          e.preventDefault();
          const button = form.querySelector('button');
          button.disabled = true;
          fetch(`${window.routes.cart_add_url}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
            .then((r) => {
              if (!r.ok) throw new Error(r.status);
              button.textContent = 'Ajouté';
              button.classList.add('is-added');
              czRefreshCartBubble();
            })
            .catch(() => form.submit());
        });
      });

      document.documentElement.style.overflow = 'hidden';
      dialog.showModal();
    })
    .catch(goToCart);
}

function czRefreshCartBubble() {
  fetch(`${window.Shopify.routes.root}?sections=cart-icon-bubble`)
    .then((r) => r.json())
    .then((sections) => {
      const bubble = document.getElementById('cart-icon-bubble');
      const html = sections['cart-icon-bubble'];
      if (!bubble || !html) return;
      bubble.innerHTML = new DOMParser().parseFromString(html, 'text/html').querySelector('.shopify-section').innerHTML;
    })
    .catch(() => {});
}